module.exports = __webpack_public_path__ + "annualreview2018/static/img/operations.296711c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/operations.png
// module id = v7Rt
// module chunks = 10